module.exports = __webpack_public_path__ + "static/img/3.bd0bd82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/wechat/3.png
// module id = 3/KP
// module chunks = 1